import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onPlaylistClick", "onCreatePlaylistClick"];
import { useState } from 'react';
import I18n from 'I18n';
import { Text } from 'foundations-components/components/Text';
import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { useAddToPlaylistOptionList } from '../savedItemsHooks';
import CreatePlaylistLink from './CreatePlaylistLink';
import AddToPlaylist from './AddToPlaylist';
import { HR } from 'foundations-components/transitional/components/HR';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { CardMenu, CardMenuHeader } from '../../cardMenu/components/CardMenu';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useIsLoadingFirstPlaylistsPage = isOpen => {
  const {
    playlistsLoading
  } = useAddToPlaylistOptionList({
    skip: !isOpen
  });
  return playlistsLoading;
};
const CardMenuAddToPlaylistOption = _ref => {
  let {
      onPlaylistClick,
      onCreatePlaylistClick
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isOpen, setIsOpen] = useState(false);
  const handleOnOpenChange = e => setIsOpen(e.target.value);
  const handleAddToPlaylistsClick = () => setIsOpen(true);
  const isLoadingFirstPlaylistsPage = useIsLoadingFirstPlaylistsPage(isOpen);
  return /*#__PURE__*/_jsx(CardMenu, {
    content: {
      header: /*#__PURE__*/_jsx(CardMenuHeader, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyNav.heading.myPlaylists"
        })
      }),
      body: /*#__PURE__*/_jsx(AddToPlaylist, Object.assign({
        onPlaylistClick: onPlaylistClick
      }, props)),
      footer: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(HR, {
          distance: "flush"
        }), /*#__PURE__*/_jsx(CreatePlaylistLink, Object.assign({
          render: (content, openModal) => /*#__PURE__*/_jsx(Button, {
            block: true,
            onClick: () => {
              onCreatePlaylistClick === null || onCreatePlaylistClick === void 0 || onCreatePlaylistClick();
              openModal();
            },
            padding: "300",
            use: "link",
            children: content
          })
        }, props, {
          children: /*#__PURE__*/_jsx(Text, {
            typography: "body-100",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyCommon.cardMenu.addToNewPlaylist"
            })
          })
        }))]
      })
    },
    onOpenChange: handleOnOpenChange,
    open: isOpen && !isLoadingFirstPlaylistsPage,
    placement: "right bottom",
    children: /*#__PURE__*/_jsx(SideNavItem, {
      "data-test-id": "add-to-playlist-button",
      iconRight: isLoadingFirstPlaylistsPage ? /*#__PURE__*/_jsx(LoadingSpinner, {
        insetInlineEnd: "10px",
        position: "absolute",
        size: "extra-small"
      }) : /*#__PURE__*/_jsx(IconHolder, {
        color: "icon-interactive-default",
        icon: RightIcon,
        marginInlineEnd: "-100",
        size: "100"
      }),
      onClick: handleAddToPlaylistsClick,
      title: I18n.text('academyCommon.cardMenu.addToPlaylist')
    })
  });
};
export default CardMenuAddToPlaylistOption;